import { useState, ReactNode } from "react";
import { DialogContent, DialogActions, Button, TextField, Typography } from "@mui/material";
import { useStore } from "../../../store/store";
import { useUser } from "../../../api/useAuth";

type SoftValidationDialogContentProps = {
    content: ReactNode;
    reasonPlaceholder: string;
};

export const SoftValidationDialogContent = ({ content, reasonPlaceholder }: SoftValidationDialogContentProps) => {
    const { appDialog, reservedSlotWarning } = useStore();
    const { data: user } = useUser();
    const [reason, setReason] = useState("");
    const [showError, setShowError] = useState(false);

    const MIN_REASON_LENGTH = 10;

    const onConfirm = () => {
        if (reason.trim().length < MIN_REASON_LENGTH) {
            setShowError(true);
            return;
        }
        const userName = user ? `${user.first_name} ${user.last_name}` : "Unknown";
        const formattedReason = `${userName}: ${reason.trim()}`;
        reservedSlotWarning.handleConfirm(formattedReason);
        appDialog.toggleIsOpen();
    };

    const onCancel = () => {
        reservedSlotWarning.handleCancel();
        appDialog.toggleIsOpen();
    };

    return (
        <>
            <DialogContent>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    {content}
                </Typography>
                <TextField
                    fullWidth
                    label="Motivo"
                    placeholder={reasonPlaceholder}
                    value={reason}
                    onChange={(e) => {
                        setReason(e.target.value);
                        if (showError) setShowError(false);
                    }}
                    error={showError}
                    helperText={showError ? `Introduza pelo menos ${MIN_REASON_LENGTH} caracteres` : `${reason.length}/${MIN_REASON_LENGTH}`}
                    multiline
                    rows={2}
                    required
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="inherit">
                    Cancelar
                </Button>
                <Button onClick={onConfirm} variant="contained" color="warning">
                    Agendar Mesmo Assim
                </Button>
            </DialogActions>
        </>
    );
};

